import FAQ from "../components/FAQ";
import Main from "../components/Main";
import TermsAndConditions from "../components/TermsAndConditions";
import Registration from "../components/Registration";

const routes = [
    { path: '/faq', component: FAQ },
    { path: '/registration', component: Registration },
    { path: '/terms-and-conditions', component: TermsAndConditions },
    { path: '/', component: Main }
];

export default routes;